import { jsx as _jsx } from "react/jsx-runtime";
import PageNotFound from 'pages/PageNotFound';
import services from 'services';
import ClinicRoomsList from './List';
var ClinicRoomsPage = function () {
    if (!services.permissionService.hasPermissionToViewClinicRooms()) {
        return _jsx(PageNotFound, {});
    }
    return _jsx(ClinicRoomsList, {});
};
export default ClinicRoomsPage;
